import type { CurrencyCode } from '@rematter/frontend-lib-api-client';

import { UnitSystem } from './queryLocationGeneralPreferences';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type UpdateLocationGeneralPreferencesInput = {
  facilityId: string;
  dateFormat?: string;
  weekStartDay?: string;
  language?: string;
  timezone?: string;
  currency?: CurrencyCode | null;
  metricEnabled?: boolean;
  imperialEnabled?: boolean;
  defaultUnitSystem?: UnitSystem;
};

export const updateLocationGeneralPreferencesMutationAtom =
  createMutationAtomFactory(
    'settings.updateLocationGeneralPreferences',
    (input: UpdateLocationGeneralPreferencesInput) => ({
      updateFacilityGeneralPreferences: {
        __args: { input },
        dateFormat: true,
        weekStartDay: true,
        language: true,
        timezone: true,
        currency: true,
        allowedUnitSystems: true,
        defaultUnitSystem: true,
      },
    }),
  );
